module.exports = __webpack_public_path__ + "ab92e3fbb92958ca8336dfa753268265.svg";